class BESSAppProjectEditorFilterFields extends BESSAppProjectEditorFilter {

    constructor(editor, container) {
        super(editor,
            container.find('.app-filter-fields'),
            editor.data.items.length > 1
        );
        this.#createOption(null);

        _.each(editor.data.fields, this.#createOption.bind(this));

        if(editor.filters['fieldNo'] !== undefined) {
            this.select.val(editor.filters['fieldNo']);
        }

        this.select.unbind('change').change(function () {

            let selected = this.select.find(":selected").val();
            editor.filterByFieldNo(selected);
            this.node.addClassIf('active', selected > 0);

        }.bind(this));
    }

    updateState() {
        this.updateIsValid(this.editor.data.items.length > 1)
    }


    undo() {
        this.editor.filterByFieldNo(0);
    }

    #createOption(field, x) {
        if (field != null && field.isHidden || x === 0) {
            return;
        }
        if (field != null) {
            this._addOptionToSelect(field.label, (x + 1));
        } else {
            this._addOptionToSelect("Show all fields", 0);
        }
    }
}